
import { defineComponent, ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
import f10Api from '@/api/f10Api'
import axios from 'axios';
export default defineComponent({
  components: { Table, Nodata },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
  },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      columns: [],
      spinning: true
    })
    pageData.columns = [
      {
        title: '年份',
        dataIndex: 'year',
        key: 'year',

        width: '100px'
      },
      {
        title: '一季报',
        dataIndex: 'onePdf',
        key: 'onePdf',
        width: '100px',
        align: 'center',
        slots: { customRender: 'pdf' }
      },
      {
        title: '中报',
        dataIndex: 'towPdf',
        key: 'towPdf',
        width: '100px',
        align: 'center',
        slots: { customRender: 'pdf' }
      },
      {
        title: '三季报',
        dataIndex: 'threePdf',
        key: 'threePdf',
        width: '100px',
        align: 'center',
        slots: { customRender: 'pdf' }
      },
      {
        title: '年报',
        dataIndex: 'fourPdf',
        key: 'fourPdf',
        width: '100px',
        align: 'center',
        slots: { customRender: 'pdf' }
      },
      {
        title: '年报审计意见',
        dataIndex: 'advice',
        key: 'advice',
        width: '110px',
        align: 'center',
        slots: { customRender: 'advice' }
      },
    ]
    onMounted(() => {
      getCWF10()
    })
    const route = useRoute()
    function getCWF10(){
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        DataType: 31,
        StaticsType: 1
      }
      data.headers = {
        token: props.token
      }
      f10Api.getCWF10(data).then((res: any) => {
        interface CFObj {
            year: number,
            onePdf: string,
            towPdf: string,
            threePdf: string,
            fourPdf: string,
            advice: string
        }
        let resData:Array<CFObj> = []
        let curYear = 0
        let typePdf:Array<string> = ['onePdf','towPdf','threePdf','fourPdf']
        res.Data.map(async (item: any) => {
            let date = new Date(item.EndDate*1000)
            item.date = date
            item.y = date.getFullYear()
            item.jd = Math.ceil((date.getMonth() +1)/3)
            if(curYear != item.y){
                let obj = {
                    year: 0,
                    onePdf: '',
                    towPdf: '',
                    threePdf: '',
                    fourPdf: '',
                    advice: ''
                }
                curYear = obj.year = item.y
                resData.push(obj)
            }
            if(item.Link.indexOf('download') != -1){
                // item.Link = item.Link.split('http://www.szse.cn')[1]
                // let downRes = await axios({
                //     url: '/szApi'+item.Link,
                //     method: 'GET',
                //     response: 'blob'
                // })
                // let resBlob = new Blob([downRes.request.response],{type: 'application/pdf'})

                // item.Link = window.URL.createObjectURL(resBlob)
                // console.log('转换过的blob===',item.Link,resBlob)
                // window.open(item.Link)
                resData[resData.length -1][typePdf[item.jd-1]] = ''
            }else{
                resData[resData.length -1][typePdf[item.jd-1]] = item.Link
            }
            if(item.jd == 4){
                resData[resData.length -1].advice = item.Advice
            }
        })
        pageData.data = resData.slice(0,3) || []
        nextTick(() => {
          pageData.spinning = false
        })
      })
    }
    return {
      ...toRefs(pageData)
    }
  }
})
